
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface SigninCallbackRequest {
    advancedSearchId: string;
}

/**
 * 
 */
export class AdvancedSearchSigninApi extends runtime.BaseAPI {

    /**
     * Advanced Search Signin Callback
          */
    async signinCallbackRaw(requestParameters: SigninCallbackRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling signinCallback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/advanced-search-signin/{advancedSearchId}/submit`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Advanced Search Signin Callback
          */
    async signinCallback(requestParameters: SigninCallbackRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.signinCallbackRaw(requestParameters, initOverrides);
    }

}
